<template>
  <div id="estimate-history-detail" class="content">
    <div>
      <h2 class="page-title">お見積り履歴詳細</h2>

      <div class="row">
        <p class="col-6">
          <b-button
            class="btn-secondary ml-2"
            style="width: 180px"
            @click="back"
          >
            もどる
          </b-button>
        </p>
        <p class="col-md-6 text-right mt-4 mt-md-0">
          <md-icon>delete</md-icon>
          <button
            type="button"
            class="btn btn-link text-secondary"
            @click="isDialogDelete = true"
          >
            お見積りを削除する
          </button>
        </p>
      </div>

      <div class="detail">
        <div class="row">
          <div class="col-md-6">
            <h5 class="page-sub-title">お見積り</h5>
            <table>
              <tr>
                <th><span>お見積り番号</span></th>
                <td>
                  <span>{{ data.MITUMORI_BANGO }}</span>
                </td>
              </tr>
              <tr>
                <th><span>お見積り依頼日</span></th>
                <td>
                  <span v-if="data.TOROKU_NICHIJI">
                    {{ data.TOROKU_NICHIJI.slice(0, 10) }}
                  </span>
                </td>
              </tr>
              <tr>
                <th><span>最終更新日</span></th>
                <td>
                  <span v-if="data.KOSHIN_NICHIJI">
                    {{ data.KOSHIN_NICHIJI.slice(0, 10) }}
                  </span>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-md-6">
            <h5 class="page-sub-title">料金</h5>
            <table>
              <tr>
                <th><span>料金</span></th>
                <td>
                  <span v-if="data.RYOKIN">
                    {{ data.RYOKIN.toLocaleString() }} 円
                  </span>
                  <span v-else class="text-danger">別途お見積り</span>
                </td>
              </tr>
              <tr>
                <th><span>納期</span></th>
                <td>
                  <span>{{ data.NOUKI }}</span>
                </td>
              </tr>
              <tr>
                <th><span>お見積り有効期限日</span></th>
                <td>
                  <span v-if="data.LIMITED_NICHIJI">
                    {{ data.LIMITED_NICHIJI.slice(0, 10) }} まで有効
                  </span>
                </td>
              </tr>
            </table>
            <p class="red f-size-12 mt-2">
              ※お見積時の入力を変更する場合は、料金・納期を変更させていただく場合がございます。
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <h5 class="page-sub-title">引取先</h5>
            <table>
              <tr>
                <th><span>引取先種別</span></th>
                <td>
                  <span>{{ hSyubetuText }}</span>
                </td>
              </tr>
              <tr>
                <th><span>住所</span></th>
                <td>
                  <span v-if="data.HIKITORI_TODO_MEI">
                    <span v-if="data.HIKITORI_YUBIN1">
                      〒{{ data.HIKITORI_YUBIN1 }}-{{ data.HIKITORI_YUBIN2 }}
                      <br />
                    </span>
                    {{ data.HIKITORI_TODO_MEI }}{{ data.HIKITORI_SHIKU_MEI
                    }}{{ data.HIKITORI_BANCHI }}
                  </span>
                </td>
              </tr>
              <tr>
                <th><span>引取先</span></th>
                <td>
                  <span>{{ data.HIKITORI_MEI }}</span>
                </td>
              </tr>
              <tr>
                <th><span>TEL</span></th>
                <td>
                  <span>{{ data.HIKITORI_TEL }}</span>
                </td>
              </tr>
              <tr>
                <th><span>個人宅/一般企業</span></th>
                <td>
                  <span v-if="data.HIKITORI_KOJIN_FLG !== null">
                    {{ getText(yesNoList, data.HIKITORI_KOJIN_FLG) }}
                  </span>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-md-6">
            <h5 class="page-sub-title">納車先</h5>
            <table>
              <tr>
                <th><span>納車先種別</span></th>
                <td>
                  <span>{{ nSyubetuText }}</span>
                </td>
              </tr>
              <tr>
                <th><span>住所</span></th>
                <td>
                  <span v-if="data.NOSYA_TODO_MEI">
                    <span v-if="data.NOSYA_YUBIN1">
                      〒{{ data.NOSYA_YUBIN1 }}-{{ data.NOSYA_YUBIN2 }}
                      <br />
                    </span>
                    {{ data.NOSYA_TODO_MEI }}{{ data.NOSYA_SHIKU_MEI
                    }}{{ data.NOSYA_BANCHI }}
                  </span>
                </td>
              </tr>
              <tr>
                <th><span>納車先</span></th>
                <td>
                  <span>{{ data.NOSYA_MEI }}</span>
                </td>
              </tr>
              <tr>
                <th><span>TEL</span></th>
                <td>
                  <span>{{ data.NOSYA_TEL }}</span>
                </td>
              </tr>
              <tr>
                <th><span>個人宅/一般企業</span></th>
                <td>
                  <span v-if="data.NOSYA_KOJIN_FLG !== null">
                    {{ getText(yesNoList, data.NOSYA_KOJIN_FLG) }}
                  </span>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <h5 class="page-sub-title">車両</h5>
            <table>
              <tr>
                <th><span>車両タイプ</span></th>
                <td>
                  <span v-if="data.SYARYO_TYPE_KBN !== null">
                    {{
                      getText(
                        syaryoTypeKbnList.concat({ value: 4, text: '普通車' }),
                        data.SYARYO_TYPE_KBN
                      )
                    }}
                  </span>
                </td>
              </tr>
              <tr>
                <th><span>車名</span></th>
                <td>
                  <span>{{ data.SYARYO_MEI }}</span>
                </td>
              </tr>
              <tr>
                <th><span>名変輸送サービスを希望しますか？</span></th>
                <td>
                  <span v-if="data.MEIHEN_FLG !== null">
                    {{ getText(yesNoList, data.MEIHEN_FLG) }}
                  </span>
                </td>
              </tr>
              <tr v-if="data.MEIHEN_FLG">
                <th><span>軽自動車ですか？</span></th>
                <td>
                  <span>
                    {{ isKei ? 'はい' : 'いいえ' }}
                  </span>
                </td>
              </tr>
              <tr v-if="data.MEIHEN_FLG && !isKei">
                <th><span>管轄運輸支局</span></th>
                <td>
                  <span>{{ data.RIKUJI_MEI }}</span>
                </td>
              </tr>
              <tr v-if="isLease || data.MEIHEN_FLG">
                <th>
                  <span>自走してもよろしいですか？</span>
                </th>
                <td>
                  <span v-if="data.JISOU_KBN !== null">
                    {{ getText(jisoList, data.JISOU_KBN) }}
                  </span>
                </td>
              </tr>
              <tr>
                <th>
                  <span>いずれかの項目に当てはまりますか？</span>
                </th>
                <td>
                  <span v-if="data.NORMAL_FLG !== null">
                    {{ data.NORMAL_FLG ? 'いいえ' : 'はい' }}
                  </span>
                  <ul class="mt-2">
                    <li v-if="!isLease && data.MEIHEN_FLG">
                      自走不可（不動車・新古車）
                    </li>
                    <li>ローダウン（地面からの距離15cm以下）</li>
                    <li>高額車（車両価格500万円以上）</li>
                    <li>クラシックカー（製造年が1989年以前）</li>
                    <li>改造車（車検が通らないもの）</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th><span>長さ・幅・高さ(cm)</span></th>
                <td>
                  <span v-if="data.NAGASA">長さ:{{ data.NAGASA }}(cm)</span>
                  <span v-if="data.HABA">幅:{{ data.HABA }}(cm)</span>
                  <br />
                  <span v-if="data.TAKASA">高さ:{{ data.TAKASA }}(cm)</span>
                </td>
              </tr>
            </table>
          </div>
          <div v-if="data.MEIHEN_FLG || isLease" class="col-md-6">
            <h5 class="page-sub-title">オプション</h5>
            <table>
              <tr>
                <th>
                  <span>清掃サービス</span>
                </th>
                <td>
                  <span v-if="data.SEISOU_FLG !== null">
                    {{ getText(yesNoHopeList, data.SEISOU_FLG) }}
                  </span>
                </td>
              </tr>
              <tr v-if="data.SEISOU_FLG">
                <th>
                  <span>清掃内容</span>
                </th>
                <td>
                  <span v-if="data.SEISOU_KBN !== null">
                    {{ getText(seisoList, data.SEISOU_KBN) }}
                  </span>
                </td>
              </tr>
              <tr v-if="isLease || data.MEIHEN_FLG">
                <th>
                  <span>保管のご希望</span>
                </th>
                <td>
                  <span v-if="data.HOKAN_FLG !== null">
                    {{ getText(yesNoHopeList, data.HOKAN_FLG) }}
                  </span>
                </td>
              </tr>
              <tr v-if="data.MEIHEN_FLG">
                <th>
                  <span>ETC車載器セットアップのご希望</span>
                </th>
                <td>
                  <span v-if="data.ETC_SETUP_FLG !== null">
                    {{ getText(etcHopeList, data.ETC_SETUP_FLG) }}
                  </span>
                </td>
              </tr>
              <tr v-if="isLease && data.MEIHEN_FLG">
                <th>
                  <span>車庫証明申請受領代行のご希望</span>
                </th>
                <td>
                  <span v-if="data.SYAKOSYO_JYURYO_FLG !== null">
                    {{ getText(yesNoHopeList, data.SYAKOSYO_JYURYO_FLG) }}
                  </span>
                </td>
              </tr>
              <tr v-if="data.MEIHEN_FLG">
                <th>
                  <span>希望ナンバーのご希望</span>
                </th>
                <td>
                  <span v-if="data.KIBO_NUMBER_FLG !== null">
                    {{ getText(yesNoHopeList, data.KIBO_NUMBER_FLG) }}
                  </span>
                </td>
              </tr>
              <tr v-if="data.MEIHEN_KIBO_NUMBER_DAIKO_FLG !== null">
                <th>
                  <span>希望番号の申請代行のご希望</span>
                </th>
                <td>
                  <span>
                    {{
                      getText(yesNoHopeList, data.MEIHEN_KIBO_NUMBER_DAIKO_FLG)
                    }}
                  </span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div :class="['history col-md-8 px-0', $mq]">
        <h5 class="page-sub-title">お問い合わせ履歴</h5>

        <md-table v-if="isRirekiLoading">
          <md-table-row>
            <md-progress-bar class="progress-bar" md-mode="indeterminate" />
            <p class="text-center">Loading...</p>
          </md-table-row>
        </md-table>
        <md-table
          v-else
          v-model="mitumoriList"
          :class="['mx-0', { mobile: isMobile }]"
          md-card
          md-fixed-header
          fixed-header
        >
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <template v-if="isMobile">
              <mobile-cell :label="getText(historyHeaders, 'KOSHIN_NICHIJI')">
                <template #cell>
                  {{ item.KOSHIN_NICHIJI }}
                </template>
              </mobile-cell>
              <mobile-cell :label="getText(historyHeaders, 'KOSHIN_MEI')">
                <template #cell>
                  {{ item.KOSHIN_MEI }}
                  <span v-if="!item.LOGICO_FLG">様</span>
                </template>
              </mobile-cell>
              <mobile-cell :label="getText(historyHeaders, 'NAIYOU')">
                <template #cell>
                  <span v-if="item.NAIYOU" v-html="sanitize(item.NAIYOU)" />
                </template>
              </mobile-cell>
              <mobile-cell
                :label="getText(historyHeaders, 'MAIL')"
                :is-right="true"
              >
                <template #cell>
                  <md-button
                    v-if="item.MAIL"
                    class="md-icon-button"
                    @click="showDialogMail(item)"
                  >
                    <md-icon class="text-success">getEmailIcon(item)</md-icon>
                  </md-button>
                </template>
              </mobile-cell>
            </template>

            <template v-else>
              <md-table-cell
                :md-label="getText(historyHeaders, 'KOSHIN_NICHIJI')"
              >
                {{ item.KOSHIN_NICHIJI }}
              </md-table-cell>
              <md-table-cell :md-label="getText(historyHeaders, 'KOSHIN_MEI')">
                {{ item.KOSHIN_MEI }}
                <span v-if="!item.LOGICO_FLG">様</span>
              </md-table-cell>
              <md-table-cell :md-label="getText(historyHeaders, 'NAIYOU')">
                <span v-if="item.NAIYOU" v-html="sanitize(item.NAIYOU)" />
              </md-table-cell>
              <md-table-cell :md-label="getText(historyHeaders, 'MAIL')">
                <md-button
                  v-if="item.MAIL"
                  class="md-icon-button"
                  @click="showDialogMail(item)"
                >
                  <md-icon class="text-warning">
                    {{ getEmailIcon(item) }}
                  </md-icon>
                </md-button>
              </md-table-cell>
            </template>
          </md-table-row>
        </md-table>
      </div>
    </div>

    <b-button
      class="btn-secondary mt-4 ml-4"
      style="width: 180px"
      @click="back"
    >
      もどる
    </b-button>

    <md-card v-if="!isOrdered" :class="['order right-side mb-4', $mq]">
      <md-card-content>
        <p class="text-center mb-2">
          <b-button class="btn-primary" @click="isDialogInquiry = true">
            お問い
            <br />
            合わせ
          </b-button>
        </p>
        <p v-if="isOrder" class="text-center">
          <b-button class="btn-success" @click="isDialogOrder = true">
            ご発注
          </b-button>
        </p>
      </md-card-content>
    </md-card>

    <md-dialog
      :md-active.sync="isDialogMail"
      :md-fullscreen="false"
      class="email new"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
    >
      <div v-if="emailBody" class="p-4" v-html="sanitize(emailBody)" />
      <md-dialog-actions class="mx-3">
        <button
          type="button"
          class="btn btn-link mr-3"
          @click="isDialogMail = false"
        >
          閉じる
        </button>
      </md-dialog-actions>
    </md-dialog>

    <inquiry-dialog
      :mitumori-data="{ ID: data.ID, MITUMORI_BANGO: data.MITUMORI_BANGO, STATUS: data.STATUS }"
      :is-active.sync="isDialogInquiry"
      @rireki-added="handleRirekiAdded"
      @success="getData"
    />

    <OrderConfirmDialog
      v-model="isDialogOrder"
      :mitumori="data"
      @order="order"
      @retry-estimate="retryEstimate"
      @opened="scroll('locked')"
      @closed="scroll('clear')"
    />

    <md-dialog-confirm
      class="new"
      :md-active.sync="isDialogDelete"
      md-title="削除確認"
      md-content="削除してもよろしいですか？"
      md-confirm-text="はい"
      md-cancel-text="いいえ"
      @md-cancel="isDialogDelete = false"
      @md-confirm="deleteItem"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
    />

    <md-snackbar
      :class="snackbarClass"
      md-position="center"
      :md-active.sync="isSnackbar"
      md-persistent
    >
      <span>{{ snackbarText }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import MobileCell from '@/components/base/MobileCell'
import InquiryDialog from '@/components/estimate/InquiryDialog'
import MitumoriMixin from '@/components/mixin/MitumoriMixin'
import Mixin from '@/components/mixin/Mixin'
import Const from '@/const'
import Store from '@/store/index.js'
import _ from 'lodash'
import OrderConfirmDialog from './OrderConfirmDialog'

const fields = {
  mitumori: '*',
  mitumori_rireki: [
    'ID',
    'NAIYOU',
    'KIDOKU_FLG',
    'LOGICO_FLG',
    'SHOW_NAVI_FLG',
    'MAIL',
    'KOSHIN_MEI',
    'KOSHIN_NICHIJI',
  ],
}
export default {
  name: 'EstimateDetail',
  components: {
    MobileCell,
    InquiryDialog,
    OrderConfirmDialog,
  },
  mixins: [Mixin, MitumoriMixin],
  data: () => ({
    /** メールDialog */
    isDialogMail: false,

    /** メール本文 */
    emailBody: null,

    /** スナックバー表示フラグ */
    isSnackbar: false,

    /**スナックバークラス */
    snackbarClass: 'bg-success',

    /** スナックバーテキスト */
    snackbarText: null,

    /** お問い合わせDialog表示フラグ */
    isDialogInquiry: false,

    /** 発注 */
    isDialogOrder: false,

    /** 削除ダイアログ表示フラグ */
    isDialogDelete: false,

    /** 見積データ */
    data: { mitumori_rireki: [] },

    /** 見積履歴ローディングフラグ */
    isRirekiLoading: false,

    /** 履歴テーブルヘッダ */
    historyHeaders: [
      { text: '更新日時', value: 'KOSHIN_NICHIJI' },
      { text: '更新者', value: 'KOSHIN_MEI' },
      { text: '内容', value: 'NAIYOU' },
      { text: 'メール', value: 'MAIL' },
    ],
  }),

  async mounted() {
    this.getData()
  },

  methods: {
    /** 見積を取得 */
    async getData() {
      this.spinerOn()
      Store.dispatch('mitumori/find', {
        cond: { ID: this.$route.params.id },
        fields: fields,
      })
        .then((list) => {
          if (!list.length) return this.back()
          this.data = list[0]
        })
        .catch((err) => {
          this.snackbarText = 'エラーが発生しました code: 402'
          this.snackbarClass = 'bg-danger'
          this.isSnackbar = true
        })
      this.spinerOff()
    },

    /** メールダイアログ表示 */
    showDialogMail(item) {
      if (item.LOGICO_FLG && !item.KIDOKU_FLG) this.emailOverlooked(item)
      this.emailBody = item.MAIL
      this.isDialogMail = true
    },

    getSyubetu(hikino) {
      return this.getMitumoriSyubetu(this.data, hikino)
    },

    /**
     * 登録場所種別を返却
     * @param hikino HIKITORI or NOSYA
     */
    getSyubetuText(hikino) {
      const kbn = this.getSyubetu(hikino)
      switch (kbn) {
        case 'AUCTION':
          return 'オークション会場'
        case 'DIRECT':
          return '直接入力'
        case 'MASTER':
          return '登録済みの場所'
        case 'FAVORITE':
          return 'お気に入りの場所'
        case 'HIKINO':
          return '引納先'
        default:
          return ''
      }
    },

    /**
     * 見積履歴更新
     * @param  {Json} data 更新データ
     */
    updateMitumoriRireki(data) {
      return Store.dispatch(
        'mitumori/editRireki',
        _.merge({ MITUMORI_ID: this.data.ID }, data)
      ).catch((err) => {
        this.snackbarText = 'エラーが発生しました code: 406'
        this.snackbarClass = 'bg-danger'
      })
    },

    /**
     * メールを既読にする
     * @param  {Json} item 見積履歴
     */
    emailOverlooked(item) {
      this.updateMitumoriRireki({ ID: item.ID, KIDOKU_FLG: 1 }).then(() => {
        this.data.mitumori_rireki.map((v) => {
          if (v.ID === item.ID) v.KIDOKU_FLG = 1
          return v
        })
      })
    },

    /** 発注する*/
    order(item) {
      this.mitumoriOrder(this.data.ID)
      this.isDialogOrder = false
    },

    /**
     * 再見積りする
     */
    retryEstimate() {
      this.isDialogOrder = false
      this.$router.push({
        name: 'TrialIndex',
        params: { mitumoriData: this.data },
      })
    },

    /**
     * 履歴が追加されたときの処理
     * @param {Object} result 追加された履歴データ
     */
    handleRirekiAdded(result) {
      // 日時をフォーマット（ISO形式 → YYYY-MM-DD HH:mm:ss）
      if (result.KOSHIN_NICHIJI) {
        const date = new Date(result.KOSHIN_NICHIJI)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        const seconds = String(date.getSeconds()).padStart(2, '0')
        result.KOSHIN_NICHIJI = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      }
      // 即座にUIに反映
      this.data.mitumori_rireki.unshift(result)
    },

    /** 削除確認 */
    deleteConfirm() {
      this.isDialogDelete = true
    },

    /** 削除実行 */
    async deleteItem() {
      this.isDialogDelete = false
      this.spinerOn()
      await Store.dispatch('mitumori/delete', this.data.ID)
        .then(() => {
          this.snackbarText = '削除しました'
          this.snackbarClass = 'bg-success'
          this.isSnackbar = true
          this.back()
        })
        .catch((err) => {
          this.snackbarText = 'エラーが発生しました code: 407'
          this.snackbarClass = 'bg-danger'
          this.isSnackbar = true
        })
      this.spinerOff()
    },

    /** 戻る */
    back() {
      this.$router.push({
        name: 'EstimateIndex',
        params: this.$route.params,
      })
    },

    /**
     * 履歴のメールアイコンを返却
     * @param item 履歴
     */
    getEmailIcon(item) {
      if (!item.LOGICO_FLG) return 'forward_to_inbox'
      else return item.KIDOKU_FLG ? 'drafts' : 'email'
    },
  },

  computed: {
    /** 軽自動車か判定 */
    isKei() {
      return this.data.SYARYO_TYPE_KBN === Const.syaryoTypeKbn.kei
    },

    /** 引取種別を返却 */
    hSyubetu() {
      return this.getSyubetu('HIKITORI')
    },

    /** 納車種別を返却 */
    nSyubetu() {
      return this.getSyubetu('NOSYA')
    },

    /** 引取種別名称を返却 */
    hSyubetuText() {
      return this.getSyubetuText('HIKITORI')
    },

    /** 納車種別名称を返却 */
    nSyubetuText() {
      return this.getSyubetuText('NOSYA')
    },

    /** 発注可能か */
    isOrder() {
      return !this.isOrdered && this.data.RYOKIN
    },

    /** 発注済みか */
    isOrdered() {
      return this.data.STATUS === Const.status.jyucyu
    },

    /** 見積履歴 */
    mitumoriList() {
      return this.data.mitumori_rireki.filter((v) => v.SHOW_NAVI_FLG)
    },
  },
}
</script>

<style lang="sass">
@import '../../assets/css/logico2'
/** メールダイアログ */
.email.md-dialog
  .md-dialog-container
    width: 95%
    max-width: 700px

#estimate-history-detail
  /** 詳細テーブル */
  .detail
    table
      font-size: 14px
      margin: 0
      th
        padding: 10px 8px
        background: $baseBlueColor
        color: #fff
        width: 30%
      td
        padding: 10px 8px
        width: 70%

  /** お問い合わせテーブル(pcのみ) */
  .history.pc
    /** 内容の長さ */
    td:nth-child(3) div
      width: 320px
    /** メール項目の位置 */
    th:last-child div,
    td:last-child div
      text-align: right

  /** 発注ボタンカード */
  .order.md-card
    bottom: 80px
    background: lightyellow
    max-width: 130px
    position: -webkit-sticky
    position: sticky
    display: block
    z-index: 2
    .md-card-content
      padding: 10px !important
    button
      font-weight: bold
      width: 100px
      height: 80px
  .order.md-card.sp
    margin-right: 15px !important

  .progress-bar
    margin: 5px auto
    width: 95%
</style>



// WEBPACK FOOTER //
// src/components/estimate/Detail.vue